import React, { CSSProperties, useCallback, useEffect, useRef } from "react";
import {
  useClickOutsideOfRef,
  useKeyPressEvent,
  useMouseEventLock,
} from "../hooks";
import { EVENT_PRIORITIES } from "./shared";

interface PopupProps {
  children: React.ReactNode | React.ReactNode[];
  isOpen: boolean;
  onClose: () => void;
  positionStyle: CSSProperties;
}

const Popup: React.FC<PopupProps> = ({
  children,
  isOpen,
  onClose,
  positionStyle,
}: PopupProps) => {
  const popupRef = useRef(null);
  useClickOutsideOfRef(popupRef, onClose);

  const closeOnEscape = useCallback((e: KeyboardEvent): void => {
    if (e.key === "Escape") {
      onClose();
    }
  }, []);

  useKeyPressEvent(
    {
      //TODO: is this right id to pass? does this hook even work?
      id: `popup___${positionStyle.top}_${positionStyle.left}`,
      priority: EVENT_PRIORITIES.POPUP,
      useCallbackGeneratedCB: closeOnEscape,
    },
    isOpen
  );

  const { pause, resume } = useMouseEventLock();

  useEffect(() => {
    if (isOpen) {
      pause();
    } else {
      resume();
    }
    return () => resume();
  }, [isOpen]);

  if (!isOpen) {
    return null;
  }

  return (
    <div
      ref={popupRef}
      className="bg-white p-2 rounded shadow absolute z-50 w-48"
      style={positionStyle}
    >
      <div>{children}</div>
    </div>
  );
};

export default Popup;
